import React, { Component } from 'react';
import { Row, Button, Input, Select, Divider, message } from 'antd';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../lib/util';
import Title  from 'antd/lib/typography/Title';
import Form from '../../lib/ui/form';
import ScheduleChanger from '../../components/schedule_changer';

class ReportConfigAddEdit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_data: this.props.edit_data || {},
            edit_id: this.props.edit_id,
            plugins: {},
            pluginSchema: []
        }


        this.list_plugins=RESTExecutor.list().config({
            label:'report_plugins'
        }).callbacks((success)=>{
            let plugins = {};
            success.result.rows.map((item) => {
                plugins[item.id] = item
            });
            this.setState({
                plugins: plugins
            });

            if (this.props.edit_id) {
                this.setState({
                pluginSchema: schema_to_field(plugins[this.props.edit_data.plugin_id].validation_config || {})
                })
            }

        }).connect(props.domains.reports);


        this.post_report=RESTExecutor.post().config({
            label:'report_configs'
        })
        .callbacks((succcess)=>{
            message.success("Report Added Successfully");
            typeof this.props.onCloseReload==='function'&&this.props.onCloseReload()
        },(error)=>{
            showErrorInNotification(error)
        })
        .connect(props.domains.reports);

        this.patch_report=RESTExecutor.patch().config({
            label:'report_configs_detail'
        })
        .callbacks((succcess)=>{
            message.success("Report Edited Successfully");
            typeof this.props.onCloseReload==='function'&&this.props.onCloseReload()
        },(error)=>{
            showErrorInNotification(error)
        })
        .connect(props.domains.reports);

    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    handlePostPatch = () => {
        if (this.state.edit_id) {
              this.patch_report.forId(this.state.edit_id).execute(this.state.form_data)
        } else {
              this.post_report.execute(this.state.form_data);
        }
    }

    render() {
        const { form_data,plugins } = this.state;

        let schedule = form_data.schedule || {};

        return (
            <div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Row type='flex' justify='center' style={{
                        flex: 1
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'right',
                            justifyContent: 'center'
                        }}
                        >
                            <span>
                                Report Name: &nbsp; <Input
                                    placeholder={"Report  Name"}
                                    onChange={(e) => {
                                        this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                                    }}
                                    value={form_data.name}
                                    style={{
                                        width: 300
                                    }} >
                                </Input>
                            </span>
                            <br></br>
                            <span>
                                Report Description: &nbsp; <Input.TextArea
                                    placeholder={"Report  Description"}
                                    onChange={(e) => {
                                        this.stateUpdater({ stateKey: 'form_data', valueKey: 'description', value: e.target.value })
                                    }}
                                    value={form_data.description}
                                    style={{
                                        width: 300
                                    }} >
                                </Input.TextArea>
                            </span>
                            <br></br>
              <span>Plugin: <Select style={{ width: 300 }}
                placeholder="Plugin"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.plugin_id}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                      this.stateUpdater({ stateKey: 'form_data', valueKey: 'plugin_params', value: {} })
                    }
                  });
                  this.setState({
                    pluginSchema: schema_to_field(plugins[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(plugins).map((key, index) => {
                    let item = plugins[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>

                        </div>
                    </Row>
                    {this.state.pluginSchema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data.plugin_params || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.stateUpdater({
                    stateKey: 'form_data',
                    valueKey: 'plugin_params',
                    value: data,
                  });
                }}
                fields={this.state.pluginSchema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}

        <Divider style={{
            marginTop: 8,
            marginBottom: 8
          }} />
          <Title style={{ margin: 0 }} level={4} type='secondary'>Schedule</Title>
          <ScheduleChanger 
          schedule={schedule}
          onChange={(schedule)=>{
            console.log("Schedule is",schedule)
            this.stateUpdater({ stateKey: 'form_data', valueKey: 'schedule', value:schedule })

          }}
          />

                    <br></br>
                    <br></br>
                    <Row type='flex' justify='space-between'>
                        <div>
                            <Button type='link' style={{ color: 'red' }} onClick={() => {
                                typeof this.props.onClose === 'function' && this.props.onClose()
                            }}>Cancel</Button>
                        </div>
                        <div>
                            <Button type='primary' onClick={() => {
                                this.handlePostPatch()
                            }}>Submit</Button>
                        </div>
                    </Row>
                </div>

            </div>
        );
    }

    componentDidMount() {
        //   list all plugins
        this.list_plugins.execute()
    }

    componentDidUpdate = (prevProps) => {

        if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
            this.list_plugins.execute()
            this.setState({
                edit_id: this.props.edit_id,
                form_data: this.props.edit_data
            })
        };

    }
}

export default withDomains(ReportConfigAddEdit,"reports");
